/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-19 16:59:14
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-04-14 11:21:52
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/mainPages/SettingPage/index.ts
 */

import FileDetail from '@/src/pages/FileDetail';
import FileLibrary from '@/src/pages/FileLibrary';
import Settings from '@/src/pages/Settings';
import DeveloperSetting from '@/src/pages/Settings/DeveloperSetting';
import Invoice from '@/src/pages/Settings/Invoice/Invoice';
import LinkLibrary from '@/src/pages/Settings/LinkLibrary';
import LinkLibraryEdit from '@/src/pages/Settings/LinkLibrary/Edit';
import StoreDetails from '@/src/pages/Settings/StoreDetails';

import Currency from '@/src/pages/Currency';
import Order from '@/src/pages/Settings/Order';
import Product from '@/src/pages/Settings/Product';
import TaxEditPage from '@/src/pages/Settings/Taxes/TaxEditPage';
import TaxListPage from '@/src/pages/Settings/Taxes/TaxListPage';

import Logistics from '@/src/pages/Settings/Logistics';
import LogisticsCourierAccountSetting from '@/src/pages/Settings/Logistics/CourierAccount/setting';
import LogisticsDeliveryMethodSetting from '@/src/pages/Settings/Logistics/DeliveryMethod/setting';
import LogisticsDestinationLanguagesSetting from '@/src/pages/Settings/Logistics/DestinationAddressLocalisation/setting';
import LogisticsPackageSetting from '@/src/pages/Settings/Logistics/Package/setting';
import LogisticsPackingSlipSetting from '@/src/pages/Settings/Logistics/PackingSlip/setting';
import LogisticsPickupLocationsSetting from '@/src/pages/Settings/Logistics/PickupLocations/setting';
import ParcelLockerSetting from '@/src/pages/Settings/Logistics/WarehouseLocations/ParcelLocker/setting';
import LogisticsWarehouseLocationsSetting from '@/src/pages/Settings/Logistics/WarehouseLocations/setting';
import PaymentEdit from '@/src/pages/Settings/Payment/PaymentEditPage';
import PaymentList from '@/src/pages/Settings/Payment/PaymentListPage';
import PlanAndBilling from '@/src/pages/Settings/PlanAndBilling/index';
import {
  CommunicationDetail,
  CommunicationList,
  CommunicationTemplateDetail,
  PermissionDetail,
  PermissionList,
  StoreSetting3rdPartyApi,
  StoreTagManager,
} from 'src/pages';

import Localisation from '@/src/pages/Settings/Localisation';

//import { EnumResources } from 'src/types/common/resources';
import { IRouteSubRoutes } from 'src/types/router';
import {
  settingGridPage,
  fileLibraryListPage,
  fileLibraryDetailPage,
  storeDetailPage,
  communicationDetailPage,
  communicationListPage,
  userPage,
  tagManagementPage,
  thirdPartyPage,
  localizationPage,
  paymentDetailPage,
  paymentListPage,
  logisticsSettingPage,
  destinationPage,
  packagePage,
  // shoppingZonePage,
  logisticsWarehousePackingSlipSettingPage,
  logisticsWarehouseCourierAccountSettingPage,
  logisticsWarehouseDeliverMethodSettingPage,
  logisticsWarehouseParcelLockerSettingPage,
  // pickupLocationPage,
  logisticsWarehouseSettingPage,
  taxDetailPage,
  taxListPage,
  orderSettingPage,
  productSettingPage,
  currencyPage,
  invoicePage,
  developerPage,
  linkLibraryDetailPage,
  linkLibraryListPage,
  billingPage,
} from '@/src/tools/permissions/storePermissions';
import {
  //EnumResources,

  EPermissionSource,
} from 'src/types/common/resources';
import { storeRoutes } from 'src/tools/urlMap';

const routes: IRouteSubRoutes[] = [
  {
    exact: true,
    path: storeRoutes.storeSettings,
    component: Settings,
    isPrivate: true,
    permissionGroup: settingGridPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeFileLibraryList, //'/settings/fileLibrary',
    component: FileLibrary,
    isPrivate: true,
    permissionGroup: fileLibraryListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeFileLibraryDetail, // '/settings/fileLibrary/:uuid',
    component: FileDetail,
    isPrivate: true,
    permissionGroup: fileLibraryDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeDetail, //'/settings/storeDetails',
    component: StoreDetails,
    isPrivate: true,
    permissionGroup: storeDetailPage,
    source: EPermissionSource.store,
  },
  {
    path: storeRoutes.storeDeveloperSetting, //'/settings/developer',
    component: DeveloperSetting,
    isPrivate: true,
    permissionGroup: developerPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLinkLibraryList, //'/settings/linkLibrary',
    component: LinkLibrary,
    isPrivate: true,
    permissionGroup: linkLibraryListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLinkLibraryDetail, // '/settings/linkLibrary/Edit/:uuid?',
    component: LinkLibraryEdit,
    isPrivate: true,
    permissionGroup: linkLibraryDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeInvoice, //'/settings/invoice',
    component: Invoice,
    isPrivate: true,
    permissionGroup: invoicePage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeCurrency, //'/settings/currency',
    component: Currency,
    isPrivate: true,
    permissionGroup: currencyPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeProductSetting, //'/settings/product',
    component: Product,
    isPrivate: true,
    permissionGroup: productSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeOrderSetting, //'/settings/order',
    component: Order,
    isPrivate: true,
    permissionGroup: orderSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeTaxList, //'/settings/tax/list',
    component: TaxListPage,
    isPrivate: true,
    permissionGroup: taxListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogistics, // '/settings/logistics',
    component: Logistics,
    isPrivate: true,
    permissionGroup: logisticsSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeTaxDetail, // '/settings/tax/edit/:uuid?',
    component: TaxEditPage,
    isPrivate: true,
    permissionGroup: taxDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsWarehouseDetail, //'/settings/logistics/warehouselocation/setting/:uuid?',
    component: LogisticsWarehouseLocationsSetting,
    isPrivate: true,
    permissionGroup: logisticsWarehouseSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsParcelLockerDetail, //'/settings/logistics/parcelLocker/setting/:warehouseUuid/:uuid?',
    component: ParcelLockerSetting,
    isPrivate: true,
    permissionGroup: destinationPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsPickupLocationDetail, // '/settings/logistics/pickuplocation/setting/:uuid?',
    component: LogisticsPickupLocationsSetting,
    isPrivate: true,
    permissionGroup: logisticsWarehouseParcelLockerSettingPage,
    source: EPermissionSource.store,
  },

  {
    exact: true,
    path: storeRoutes.storeLogisticsDeliveryMethodDetail, //'/settings/logistics/deliveryMethod/setting/:warehouseUuid/:uuid?',
    component: LogisticsDeliveryMethodSetting,
    isPrivate: true,
    permissionGroup: logisticsWarehouseDeliverMethodSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsDestinationLanguagesDetail, // '/settings/logistics/destinationLanguages/setting/:countryCode?/:countryName?',
    component: LogisticsDestinationLanguagesSetting,
    isPrivate: true,
    permissionGroup: destinationPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsCourierAccountDetail, // '/settings/logistics/courieraccount/setting/:type/:location/:warehouseUuid/:uuid?',
    component: LogisticsCourierAccountSetting,
    isPrivate: true,
    permissionGroup: logisticsWarehouseCourierAccountSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsPackingSlipDetail, // '/settings/logistics/packingslip/setting/:warehouseUuid',
    component: LogisticsPackingSlipSetting,
    isPrivate: true,
    permissionGroup: logisticsWarehousePackingSlipSettingPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeLogisticsPackageSetting, // '/settings/logistics/package/setting/:uuid?',
    component: LogisticsPackageSetting,
    isPrivate: true,
    permissionGroup: packagePage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storePaymentList, // '/settings/payment/list',
    component: PaymentList,
    isPrivate: true,
    permissionGroup: paymentListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storePaymentDetail, //'/settings/payment/edit/:gatewayProviderCode/:uuid?',
    component: PaymentEdit,
    isPrivate: true,
    permissionGroup: paymentDetailPage,
    source: EPermissionSource.store,
  },

  {
    exact: true,
    path: storeRoutes.storeLocalisation, //'/settings/localisation',
    component: Localisation,
    isPrivate: true,
    permissionGroup: localizationPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.store3rdApi, //'/settings/3rdPartyApi',
    component: StoreSetting3rdPartyApi,
    isPrivate: true,
    permissionGroup: thirdPartyPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeTagManager, //'/settings/tagManager',
    component: StoreTagManager,
    isPrivate: true,
    permissionGroup: tagManagementPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeCommunicationList, // '/settings/communicationsList',
    component: CommunicationList,
    isPrivate: true,
    permissionGroup: communicationListPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeCommunicationGatewayDetail, //'/settings/communicationDetail/:gateway/:channelType/:communicationUuid',
    component: CommunicationDetail,
    isPrivate: true,
    permissionGroup: communicationDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeCommunicationTemplateDetail, //'/settings/communicationDetail/template/:gateway/:channelType/:communicationUuid/:templateUuid',
    component: CommunicationTemplateDetail,
    isPrivate: true,
    permissionGroup: communicationDetailPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storePermissionList, //'/settings/permissionsList',
    component: PermissionList,
    isPrivate: true,
    permissionGroup: userPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storePermissionDetail, //'/settings/permissionsDetail/:userUuid',
    component: PermissionDetail,
    isPrivate: true,
    permissionGroup: userPage,
    source: EPermissionSource.store,
  },
  {
    exact: true,
    path: storeRoutes.storeBilling,
    component: PlanAndBilling,
    isPrivate: true,
    permissionGroup: billingPage,
    source: EPermissionSource.store,
  },
];

export default routes;
